/* eslint-disable import/prefer-default-export */
import api from '../_api';

export const institutionsService = {
    getImpartedCareers(careerUuid) {
        return api.get(`institutions/institution/career/${careerUuid}`);
    },
};
